export default {"src":"/_next/static/media/hardHatIcon.c9306a26.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};